export const FORBIDDEN = 403;
export const BAD_REQUEST = 400;
export const REJECTED = 401;